import React, { useRef } from 'react';
import AnimatedOnScroll from '../animateOnScroll/AnimatedOnScroll';
import './../../pg/Global.css';
import './../Palette.css';
import './TextParagraph.css';

type TextParagraphProps = {
    Type: string,
    Key: number,
    ParagraphHeader: string,
    ParagraphContent: string,
};

export let colorMap: Map<number, boolean> = new Map();
const TextParagraph: React.FC<TextParagraphProps> = ({ Type, Key, ParagraphHeader, ParagraphContent }) => {
    const mapRef = useRef(colorMap);

    let is;
    if (!mapRef.current.has(Key)) {
        is = (Key % 2) !== 0;
        mapRef.current.set(Key, is);
    } else {
        is = mapRef.current.get(Key);
    }
    let isAlt = is ? '' : ' BgAlt';
    let isAltBox = is ? ' BoxAlt' : '';

    if (Type === 'switch') {
        return (<div></div>);
    } else if (Type === 'full-title') {
        return (
            <div className={'TextParagraphWrapper' + isAlt}>
                <div className='TextParagraphWrapperCenter'>
                    <div className='TPHeaderBoxWrapper'>
                        <AnimatedOnScroll BaseClass={'TPHeaderBox' + isAltBox} AnimateClass='TPHeaderBoxAnimate' InnerHtml={null} />
                        <AnimatedOnScroll BaseClass={'TPHeaderBox2' + isAltBox} AnimateClass='TPHeaderBoxAnimate' InnerHtml={null} />
                        <div className='TPH2Wrapper' id={ParagraphHeader.replaceAll('#', '')}>
                            <AnimatedOnScroll BaseClass='TextParagraphH' AnimateClass='TextParagraphHAnimate' InnerHtml={<><h1>{ParagraphHeader}</h1></>} />
                        </div>
                    </div>
                    <a className='TextParagraphA' >{ParagraphContent}</a>
                </div>
            </div>
        );
    } else if (Type === 'full') {
        return (
            <div className={'TextParagraphWrapper' + isAlt}>
                <div className='TextParagraphWrapperCenter'>
                    <div className='TPHeaderBoxWrapper'>
                        <AnimatedOnScroll BaseClass={'TPHeaderBox' + isAltBox} AnimateClass='TPHeaderBoxAnimate' InnerHtml={null} />
                        <AnimatedOnScroll BaseClass={'TPHeaderBox2' + isAltBox} AnimateClass='TPHeaderBoxAnimate' InnerHtml={null} />
                        <div className='TPH2Wrapper' id={ParagraphHeader.replaceAll('#', '')}>
                            <AnimatedOnScroll BaseClass='TextParagraphH' AnimateClass='TextParagraphHAnimate' InnerHtml={<><h2>{ParagraphHeader}</h2></>} />
                        </div>
                    </div>
                    <a className='TextParagraphA' >{ParagraphContent}</a>
                </div>
            </div>
        );
    } else {
        return (
            <div className={'TextParagraphWrapper' + isAlt}>
                <div className='TextParagraphWrapperCenter'>
                    <div className={'TPHeaderBoxWrapperSmol' + isAlt}>
                        <div className='TPH2Wrapper'>
                            <h3 id={ParagraphHeader}>{ParagraphHeader}</h3>
                        </div>
                    </div>
                    <a className='TextParagraphA' >{ParagraphContent}</a>
                </div>
            </div>
        );
    }
};

export default TextParagraph;
